<template>
  <div class="dashboard-card">
    <div class="card-header">
      <awesomeIcon icon="exchange-alt" /> Meest recente mutaties
    </div>
    <table class="new click-tr">
      <tr
        v-for="mut in mutations" :key="mut.id"
        :class="{ 'grey': mut.superclass == 14, 'storno': mut.storno }"
      >
        <td>{{(new Date(mut.date)).toLocaleDateString()}}</td>
        <td>
          {{mut.superclass!=14 ? mut.class : mut.asset_name}}<br>
          <span v-if="mut.asset!=0&&mut.quantity!=0" class="grey concat">
            {{mut.quantity}}x {{mut.asset_name}}
          </span>
          <span v-else-if="mut.class === 'Opname'" class="grey concat">
            {{mut.asset_name}}
          </span>
          <br v-else-if="
            $parent.currentPort.brand!='Doelbeleggen'
            && $parent.currentPort.brand!='OXBY'
          ">
        </td>
        <td class="number">
          &euro;{{'\xa0'}}{{formatPrice(mut.superclass!=14 ? mut.total : mut.rate)}}
        </td>
      </tr>
    </table>
    <div class="card-bottom">
      <a class="button secondary" @click="clickMutations">
        Alle mutaties <awesomeIcon icon="exchange-alt"/>
      </a>
    </div>
  </div>
</template>

<script>
import {
  take,
  filter,
} from 'lodash-es';

export default {
  name: 'MutationsWidget',
  computed: {
    mutations() {
      return take(
        this.$parent.currentPort.brand === 'Doelbeleggen'
          ? filter(
            this.$parent.mutations,
            { grouping: 'Mutaties + overige' },
          )
          : this.$parent.mutations,
        this.$parent.currentPort.brand === 'Doelbeleggen' ? 7 : 5,
      );
    },
  },
  methods: {
    clickMutations() {
      this.$store.state.currentView = 'Mutations';
    },
  },
};
</script>

<style lang="scss" scoped>
  table.new {
    margin: 0 15px;
    width: calc(100% - 30px);
    table-layout: fixed;
    td:first-child,
    td:last-child {
      width: 70px;
    }
    .concat {
      width: 100%;
      display: inline-block;
    }
    .storno {
      text-decoration: line-through;
      color: gray;
    }
  }
</style>
